'use client'

import { PrivyClientConfig, PrivyProvider } from '@privy-io/react-auth'
import { bsc, bscTestnet } from 'viem/chains'

const privyConfig: PrivyClientConfig = {
  defaultChain: process.env.enviroment === 'development' ? bscTestnet : bsc,
  supportedChains: process.env.enviroment === 'development' ? [bscTestnet] : [bsc],
  appearance: {
    accentColor: '#9e77ed',
    theme: '#0A0F1A',
    showWalletLoginFirst: false,
    logo: '/ss-logo-white.svg',
    walletChainType: 'ethereum-only',
    walletList: ['detected_wallets', 'wallet_connect'],
  },
  loginMethods: ['wallet', 'email', 'google', 'twitter'],
  fundingMethodConfig: {
    moonpay: {
      useSandbox: true,
      paymentMethod: 'mobile_wallet',
    },
  },
  embeddedWallets: {
    requireUserPasswordOnCreate: false,
    showWalletUIs: true,
    createOnLogin: 'users-without-wallets',
    extendedCalldataDecoding: true,
  },
  mfa: {
    noPromptOnMfaRequired: false,
  },
  externalWallets: {
    walletConnect: {
      enabled: true,
    },
  },
  walletConnectCloudProjectId: 'fe8057068d5509388e90c2712260d4bb',
}
export const PrivyAuthProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <PrivyProvider appId={process.env.NEXT_PUBLIC_PRIVY_APP_ID as string} config={privyConfig}>
      {children}
    </PrivyProvider>
  )
}
